import React from 'react';

const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';

export const AppVersionBadge = ({ version = APP_VERSION }) => {
  return (
    <div className="app-version" aria-label={`App version ${version}`}>
      v{version}
    </div>
  );
};
